import React, { useEffect, useRef, useState } from 'react';
import { View, Platform, Image } from 'react-native';


import AppTheme from "../../utils/Theme";

// Assets
import Images from "../../../specific/utils/Images";
import { UserType } from '../Authentication/Landing/Landing';
import User from '../../data/user/User';

interface DynamicBackgroundProps {
    type?: UserType,
    isMenu?: boolean
}

const DynamicBackground = (props: DynamicBackgroundProps) => {

    const [isLoading, setIsLoading] = useState<boolean>(true);

    const appTheme: AppTheme = new AppTheme();
    const images: Images = new Images();

    const user: User = User.getInstance();

    const getContent = () => {
        let userType: UserType | undefined = ((user !== undefined) && (user.profile !== undefined)) ? user.profile : undefined;
        if (userType === undefined) {
            if (props.type !== undefined) {
                userType = props.type;
            } else {
                userType = "neutral";
            }
        }

        let backgroundColor = appTheme.neutralBackgroundColor;

        if (userType === "family") {
            backgroundColor = appTheme.parentBackgroundColor;
        } else if (userType === "animator") {
            backgroundColor = appTheme.animatorBackgroundColor;
        } else if (userType === "teacher") {
            backgroundColor = appTheme.schoolBackgroundColor;
        }
        let contentView = <View />;
        const widthForBackground = appTheme.getFullScreenWidth();
        const heightForBackground = appTheme.getFullScreenHeight() * 3 / 4;
        if (userType === "neutral") {
            contentView = <View>
                <View style={{
                    width: widthForBackground,
                    height: heightForBackground
                }} />
                <Image
                    source={images.bgDayGrass}
                    style={{
                        width: appTheme.getFullScreenWidth(),
                        height: appTheme.getFullScreenHeight() * 1 / 4,
                        backgroundColor: "#00B590"
                    }}
                    resizeMode="repeat" />
            </View>
        } else if (userType === "family") {
            contentView = <View>
                <View style={{
                    width: widthForBackground,
                    height: heightForBackground
                }} />
                <Image
                    source={images.bgOnboardingParent}
                    style={{
                        width: appTheme.getFullScreenWidth(),
                        height: appTheme.getFullScreenHeight()
                    }}
                    resizeMode="cover" />
            </View>
        } else {
            contentView = <View style={{
                width: widthForBackground,
                height: heightForBackground
            }} />
        }


        const position = Platform.OS === "web" ? "fixed" : "absolute";

        return <View style={{
            width: appTheme.getFullScreenWidth(),
            height: appTheme.getFullScreenHeight(),
            backgroundColor: backgroundColor,
            position,
            justifyContent: "flex-start",
            alignItems: "flex-start"
        }}>
            {contentView}
        </View>;
    }

    return getContent();
}

export default DynamicBackground;